import { SeloDaCampanha } from '../cptu/CampanhaMoldura';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listarCampanhasSpt, metro, type CampanhaSptDaLista } from '../../api/spt';
import { plural } from '../../formato';
import { Carregando, ErroDaApi } from '../../ui';
import { JanelaDeNovaCampanhaSpt } from './CampanhasSpt';

/** As campanhas SPT desta OS, no Campo da OS — onda 356 (spec 12 §5.1). */
export function SondagensSptDaOs({ os, podeCriar }: { os: { id: string; numero: string }; podeCriar: boolean }) {
  const [linhas, setLinhas] = useState<CampanhaSptDaLista[] | null>(null);
  const [erro, setErro] = useState<unknown>(null);
  const [nova, setNova] = useState(false);
  useEffect(() => {
    let vivo = true;
    listarCampanhasSpt({ os: os.id }).then((r) => { if (vivo) setLinhas(r); }).catch((e) => { if (vivo) setErro(e); });
    return () => { vivo = false; };
  }, [os.id]);
  return (
    <div className="cartao campanhas-da-os">
      <div className="cartao-cabeca">
        <h2>Sondagens SPT desta OS</h2>
        <span className="sub cresce">
          {linhas == null ? 'carregando' : linhas.length === 0 ? 'nenhuma campanha' : plural(linhas.length, 'campanha', 'campanhas')}
        </span>
        {podeCriar && <button type="button" className="botao secundario" onClick={() => setNova(true)}>＋ Nova campanha SPT</button>}
      </div>
      {erro ? <ErroDaApi erro={erro} />
        : !linhas ? <Carregando texto="Carregando as sondagens SPT da OS" />
        : linhas.length === 0 ? <p className="sub">Nenhuma sondagem SPT nesta OS. A campanha reúne os furos transcritos dos boletins de campo.</p>
        : (
          <ul className="spt-lista-da-os">
            {linhas.map((c) => (
              <li key={c.id}>
                <Link to={`/spt/${c.id}`} className="mono">{c.numero}</Link> · {c.titulo}
                <span className="sub"> · {plural(c.furos, 'furo', 'furos')}{c.furos ? ` · ${metro(c.metragem)} m` : ''}</span>
                {' '}<SeloDaCampanha situacao={c.situacao} />
              </li>
            ))}
          </ul>
        )}
      {nova && <JanelaDeNovaCampanhaSpt os={os} aoFechar={() => setNova(false)} />}
    </div>
  );
}
